"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_MIN_SCANS = void 0;
exports.DEFAULT_MIN_SCANS = 3;
//# sourceMappingURL=scan.js.map